import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InfoBall from "./InfoBall";

const InfoBallSection = ({ items, label = null }) => {
  return (
    <section>
      <Container>
        <Row>
          {label ? (
            <Col xs={12} className="text-center mb-6">
              <h2>{label}</h2>
            </Col>
          ) : (
            ""
          )}
          <Col xs={12} className="d-flex flex-wrap justify-content-center">
            {items.map((item, index) => (
              <InfoBall key={index} icon={item.icon} label={item.label} />
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default InfoBallSection;
